
import Vue from "vue";

export default Vue.extend({
  props: {
    stepAmount: {
      type: Number,
      default: 10
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onChange(value: any) {
      if ((this as any).disabled) {
        return;
      }

      this.$emit("input", value);
      this.$emit("change", value);
    },
    onIncrement() {
      const stepAmount = (this as any).stepAmount;
      const newEarnRate =
        Math.floor((Number((this as any).value) + stepAmount) / stepAmount) *
        stepAmount;

      (this as any).onChange(newEarnRate);
    },
    onDecrement() {
      const stepAmount = (this as any).stepAmount;

      // Can't go lower than 0
      if ((this as any).value <= 0) return;

      const newEarnRate =
        Math.floor((Number((this as any).value) - stepAmount) / stepAmount) *
        stepAmount;

      (this as any).onChange(newEarnRate);
    },
    validate() {
      (this.$refs.textInput as any).validate();
    },
    onBlur() {
      (this as any).$emit("blur");

      // re-validate to overcome issues with vuetify errors not updating
      // correctly. May be a race condition or reactivity issue with vuelidate and vuex?
      this.$nextTick(() => (this as any).validate());
    }
  }
});
